<template>
  <div class="relative sm:py-16">
    <div
      class="mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8"
    >
      <div
        class="relative rounded-2xl px-6 py-10 bg-indigo-100 overflow-hidden shadow-xl sm:px-12 sm:py-20"
      >
        <div class="relative">
          <div class="text-center">
            <h2
              class="text-3xl font-extrabold text-black tracking-tight sm:text-4xl"
            >
              Create a new team
            </h2>
          </div>
          <RadioGroup v-model="form.accountType">
            <RadioGroupLabel
              class="text-base mt-10 font-medium text-gray-900 grid justify-items-center"
            >
              What are your services?
            </RadioGroupLabel>

            <div
              class="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4"
            >
              <RadioGroupOption
                v-for="accountType in accountTypes"
                :key="accountType.id"
                v-slot="{ checked, active }"
                as="template"
                :value="accountType.id"
              >
                <div
                  :class="[
                    checked
                      ? 'border-transparent'
                      : 'border-gray-300',
                    active ? 'ring-2 ring-indigo-500' : '',
                    'relative bg-white border rounded-lg shadow-sm p-4 flex cursor-pointer focus:outline-none',
                  ]"
                >
                  <div class="flex-1 flex">
                    <div class="flex flex-col">
                      <RadioGroupLabel
                        as="span"
                        class="block text-sm font-medium text-gray-900"
                      >
                        {{ accountType.title }}
                      </RadioGroupLabel>
                      <RadioGroupDescription
                        as="span"
                        class="mt-1 flex items-center text-sm text-gray-500"
                      >
                        {{ accountType.description }}
                      </RadioGroupDescription>
                    </div>
                  </div>
                  <CheckCircleIcon
                    :class="[
                      !checked ? 'invisible' : '',
                      'h-5 w-5 text-indigo-600',
                    ]"
                    aria-hidden="true"
                  />
                  <div
                    :class="[
                      active ? 'border' : 'border-2',
                      checked
                        ? 'border-indigo-500'
                        : 'border-transparent',
                      'absolute -inset-px rounded-lg pointer-events-none',
                    ]"
                    aria-hidden="true"
                  />
                </div>
              </RadioGroupOption>
            </div>
          </RadioGroup>
          <form
            class="mt-5 sm:mx-auto sm:max-w-lg sm:flex"
            @submit.prevent="createTeam"
          >
            <div class="min-w-0 flex-1">
              <jet-label for="name" />
              <jet-input
                id="name"
                v-model="form.name"
                type="text"
                class="block w-full border border-transparent rounded-md px-5 py-3 text-base text-gray-900 placeholder-gray-500 shadow-sm focus:outline-none focus:border-transparent focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-600"
                placeholder="Enter Team Name"
                autofocus
              />
              <jet-input-error
                :message="form.errors.name"
                class="mt-2"
              />
            </div>
            <div class="mt-4 sm:mt-0 sm:ml-3">
              <jet-button
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing"
                class="block w-full rounded-md border border-transparent px-5 py-3 bg-indigo-500 text-base font-medium text-white shadow hover:bg-indigo-400 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-indigo-600 sm:px-10"
              >
                Create
              </jet-button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  RadioGroup,
  RadioGroupDescription,
  RadioGroupLabel,
  RadioGroupOption,
} from '@headlessui/vue';
import { CheckCircleIcon } from '@heroicons/vue/24/solid';
import JetButton from '../../Jetstream/Button.vue';
import JetInput from '../../Jetstream/Input.vue';
import JetInputError from '../../Jetstream/InputError.vue';
import JetLabel from '../../Jetstream/Label.vue';
import AppCreateTeamLayout from '../../Layouts/AppCreateTeamLayout.vue';

const accountTypes = [
  {
    id: 'operator',
    title: 'Tour Operator',
    description: 'For tour operators providing organized travel',
  },
  {
    id: 'guide',
    title: 'Tour Guide',
    description:
            'For local tour guides looking to organize their calendar and get in contact with tour operators in their area',
  },
];

export default {
  components: {
    JetButton,
    JetInput,
    JetInputError,
    JetLabel,
    RadioGroup,
    RadioGroupDescription,
    RadioGroupLabel,
    RadioGroupOption,
    CheckCircleIcon,
  },
  layout: AppCreateTeamLayout,
  setup() {
    return {
      accountTypes,
    };
  },

  data() {
    return {
      form: this.$inertia.form({
        name: '',
        accountType: accountTypes[0].id,
      }),
    };
  },

  methods: {
    createTeam() {
      this.form.post(route('teams.store'), {
        errorBag: 'createTeam',
        preserveScroll: true,
      });
    },
  },
};
</script>
